import { render, staticRenderFns } from "./IconRedo.vue?vue&type=template&id=649fe354"
import script from "./IconRedo.vue?vue&type=script&lang=js"
export * from "./IconRedo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports